export enum PaymentModel {
  PPV = 'ppv',
  PPD = 'ppd',
}

export enum CalculationModel {
  Dynamic = 'dynamic',
  Fixed = 'fixed',
}
